import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

let api = process.env.API_URL
let prefix = '/users'

export default {
  get: {
    search (search) {
      return Vue.http.get(api + prefix + '/search/' + search)
    },
    relations () {
      return Vue.http.get(api + prefix + '/relations/')
    },
    byUsername (username) {
      return Vue.http.get(api + prefix + '/username/' + username)
    },
    leaderboard () {
      return Vue.http.get(api + prefix + '/leaderboard/')
    },
    me () {
      return Vue.http.get(api + prefix + '/me/')
    }
  },
  post: {
    follow (body) {
      return Vue.http.post(api + prefix + '/follow', body)
    },
    unfollow (body) {
      return Vue.http.post(api + prefix + '/unfollow', body)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/users.js